<template>
  <JoszakiCard hoverable class="flex flex-col gap-2">
    <div
      class="flex items-center flex-row cursor-pointer gap-2 py-2"
      @click="onHeaderClick"
    >
      <IconComponent
        v-if="icon"
        :icon="icon"
        :pack="iconPack"
        class="w-5"
        :class="iconClass"
      />
      <span
        v-if="$scopedSlots.title"
        class="flex-1"
        :class="titleClass"
        @click.stop="() => {}"
      >
        <slot name="title" />
      </span>
      <span
        v-else
        class="font-bold text-lg md:text-xl flex-1"
        :class="titleClass"
      >
        {{ title }}
      </span>
      <span
        v-if="$scopedSlots.actions"
        class="flex flex-row gap-2 items-center"
        @click.stop="() => {}"
        ><slot name="actions"
      /></span>
      <IconComponent v-if="isOpen" icon="angle-down" class="w-8" />
      <IconComponent v-else icon="angle-right" class="w-8" />
    </div>
    <div v-show="isOpen" ref="contentWrapper" :class="innerClass">
      <slot />
    </div>
  </JoszakiCard>
</template>

<script>
export default {
  name: "JoszakiCollapsibleCard",
  props: {
    titleClass: {
      type: [String, Object],
      default: "",
    },
    innerClass: {
      type: [String, Object],
      default: "",
    },
    icon: {
      type: String,
      default: null,
    },
    iconPack: {
      type: String,
      default: "fas",
    },
    iconClass: {
      type: String,
      default: "text-primary",
    },
    title: {
      type: String,
      default: "",
    },
    isOpenByDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: this.isOpenByDefault,
    };
  },
  watch: {
    isOpenByDefault(newValue) {
      this.isOpen = newValue;
    },
  },
  mounted() {
    this.checkContent();
  },
  updated() {
    this.$nextTick(() => {
      this.checkContent();
    });
  },
  methods: {
    onHeaderClick() {
      if (this.hasContent) {
        this.isOpen = !this.isOpen;
      }

      this.$emit("toggle");
      if (this.isOpen) {
        this.$emit("open");
      } else {
        this.$emit("close");
      }
    },
    checkContent() {
      const wrapper = this.$refs.contentWrapper;
      if (wrapper) {
        // Check if there are any child nodes that aren't comments
        this.hasContent = Array.from(wrapper.childNodes).some(
          (node) => node.nodeType !== Node.COMMENT_NODE
        );

        if (!this.hasContent) {
          this.isOpen = false;
        }
      }
    },
  },
};
</script>
